import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import VideoPreviewModal from "../Video/VideoPreviewModal";
import { FILE_TYPE_ID } from "../../lib/constants";

interface MultimediaData {
  fileType: number;
  filePath: string;
}

interface MediaSwiperProps {
  mediaList: MultimediaData[];
  onMediaClick?: (media: MultimediaData) => void;
}

const MediaSwiper: React.FC<MediaSwiperProps> = ({
  mediaList,
  onMediaClick,
}) => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [currentMedia, setCurrentMedia] = useState<MultimediaData | null>(null);

  const handleMediaClick = (media: MultimediaData) => {
    setCurrentMedia(media);
    setIsPreviewOpen(true);
    if (onMediaClick) {
      onMediaClick(media);
    }
  };

  const closePreview = () => {
    setIsPreviewOpen(false);
    setCurrentMedia(null);
  };

  return (
    <div className="carousel-container my-4">
      <Swiper
        slidesPerView={3}
        spaceBetween={15}
        pagination={{ clickable: true }}
        modules={[Pagination]}
        style={{ height: "180px" }}
      >
        {mediaList.map((media, index) => (
          <SwiperSlide key={index}>
            <div className="relative w-full h-full aspect-square">
              {media.fileType === FILE_TYPE_ID.VIDEO ? (
                <div className="relative">
                  <video
                    src={media.filePath}
                    className="w-[200px] h-[150px] object-cover cursor-pointer rounded"
                    preload="metadata"
                    onLoadedData={(e) => {
                      e.currentTarget.currentTime = 0.1;
                    }}
                    onClick={() => handleMediaClick(media)}
                  />
                  <div
                    className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30 hover:bg-opacity-50 cursor-pointer"
                    onClick={() => handleMediaClick(media)}
                  >
                    <span className="text-white text-4xl">▶</span>
                  </div>
                </div>
              ) : (
                <img
                  src={media.filePath}
                  alt="review-image"
                  className="w-[200px] h-[150px] object-cover cursor-pointer rounded"
                  onClick={() => handleMediaClick(media)}
                />
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Conditional Rendering of Media Preview in Dialog */}
      {isPreviewOpen && currentMedia && (
        <VideoPreviewModal
          videoSrc={currentMedia.filePath}
          fileType={Number(currentMedia.fileType)}
          isOpen={isPreviewOpen}
          onClose={closePreview}
        />
      )}
    </div>
  );
};

export default MediaSwiper;
